import SorterSvg from 'assets/sorter.svg'
import { Box, PopOver, PopOverItemType, Skeleton } from 'components'
import { FixMeAny, UnknownRecord } from 'types/global'

export type FilterItem = {
  key: string
  title: string
  multiselect?: boolean
  selectall?: boolean
  searcheable?: boolean
  options: PopOverItemType<FixMeAny>[]
}

type Props<T extends UnknownRecord> = {
  filters?: FilterItem[]
  onChange: (values: T) => void
  values?: T | null
  isLoading?: boolean
}

const Filters = <T extends UnknownRecord>({ filters, onChange, values, isLoading }: Props<T>) => {
  const handleChange = (keyName: string) => (value?: PopOverItemType[]) => {
    const selectedValues = value?.map((i) => i.value) || []
    onChange({ ...(values ?? {}), [keyName]: selectedValues } as T)
  }

  const getValue = (keyName: string, options: PopOverItemType[]) =>
    values?.[keyName]?.map((i: FixMeAny) => options.find((j) => j.value === i) ?? { label: i, value: i })

  if (isLoading) {
    return <Skeleton height="40px" width="500px" />
  }

  if (!filters || filters.length === 0) {
    return null
  }

  return (
    <Box display="flex" alignItems="center" gap="10px">
      <Box display="flex" alignItems="center" height={35}>
        <SorterSvg />
      </Box>
      {filters.map((filter, idx) => (
        <PopOver
          key={idx}
          onChange={handleChange(filter.key)}
          value={getValue(filter.key, filter.options)}
          name={filter.key}
          title={filter.title}
          options={filter.options}
          isSearchable={filter.searcheable ?? true}
          isMultiple={filter.multiselect ?? true}
          isWithSelectAll={filter.selectall ?? true}
        />
      ))}
    </Box>
  )
}

export default Filters
